import { I18n } from 'react-redux-i18n'
import React from 'react'

import dkvConfiguration from 'constants/dkv.constants'
const { crmUrl } = dkvConfiguration

const LinkCRM = ({ metadata }) => {
  const { tipocliente, guidcliente } = metadata || {}

  let path = ''
  if (guidcliente) {
    const entity = tipocliente !== 'CONTACTO' ? 'account' : 'contact'

    path += `/main.aspx?etn=${entity}&id=${guidcliente}&pagetype=entityrecord`
  }

  return (
    <a href={`${crmUrl}${path}`} className='btn btn-primary link_as_btn' target='_black' role='button'>
      {I18n.t('buttons_crm')}
    </a>
  )
}

export default LinkCRM
